import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Models
import { PaymentsData } from 'src/app/modules/payments/models/payments';

// Services
import { PaymentsService } from 'src/app/modules/payments/payments.service';

@Component({
  selector: 'app-payments-receipt',
  templateUrl: './payments-receipt.component.html',
  styleUrls: ['./payments-receipt.component.scss']
})
export class PaymentsReceiptComponent implements OnInit {
  public payment: PaymentsData;
  @ViewChild('reciptElement', { static: true }) reciptElement: ElementRef;

  constructor(
    public dialog: MatDialogRef<PaymentsReceiptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { payment: PaymentsData },
    private paymentsService: PaymentsService
  ) { }

  ngOnInit(): void {
    this.payment = this.data.payment;
  }

  onCancel(): void {
    this.dialog.close();
  }

  onDownload(): void {
    const data = document.getElementById('reciptElement')!;

    this.paymentsService.paymentReceiptPDF(data, this.payment.recipt);
  }
}
